import * as React from 'react'
import Background from '../background/Background'
import Title from '../titlte/Title'
import Searchfield from '../search/Searchfield'

import Card from '../cards/Card'
import { wishCategories } from '../wishes/wishes'

interface HomeState {
  searchValue: string
}

interface HomeProps {}

class Home extends React.Component<HomeProps, HomeState> {
  constructor(props: HomeProps) {
    super(props)
    this.state = {
      searchValue: '',
    }
  }
  render() {
    return (
      <div style={{ height: '100vh', overflow: 'hidden' }}>
        <Background style={{ padding: '16px', display: 'flex', flexDirection: 'column', color: 'white' }}>
          <Title>Jetzt ein ...</Title>
          <Searchfield
            style={{
              marginTop: '20px',
              marginBottom: '20px',
            }}
            value={this.state.searchValue}
            onChange={e =>
              this.setState({
                searchValue: e.currentTarget.value,
              })
            }
          />
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              position: 'relative',
              overflow: 'auto',
              justifyContent: 'space-between',
            }}
          >
            {wishCategories
              .filter(wish => wish.name.toLowerCase().includes(this.state.searchValue.toLowerCase()))
              .map(wish => (
                <Card wish={wish} key={wish.type} />
              ))}
          </div>
        </Background>
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/routes/Home.tsx